__turbopack_context__.v({
  "className": "space_grotesk_e9e18cdd-module__FwnvIG__className",
  "variable": "space_grotesk_e9e18cdd-module__FwnvIG__variable",
});
